(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ConfirmFiservStatusDialogController', ConfirmFiservStatusDialogController);

    ConfirmFiservStatusDialogController.$inject = [ '$scope', '$uibModalInstance' ];

    function ConfirmFiservStatusDialogController ($scope, $uibModalInstance) {
		var confirmFiservStatusDlgCtr = this;
		confirmFiservStatusDlgCtr.errorMessage = null;
		confirmFiservStatusDlgCtr.checkCancel = false;

		 confirmFiservStatusDlgCtr.close = function() {
			$uibModalInstance.dismiss('cancel');
		};

		confirmFiservStatusDlgCtr.submit = function(content) {
			$uibModalInstance.close(content);		 
		};
	}
})();
